import Typography from "@/components/shared/Typography"
import { ROUTES } from "@/conf"
import Image from "next/image"
import Link from "next/link"

interface ArticleItemProps {
  imageSrc: string
  title: string
  subtitle: string
  link: string
}

const ArticleItem = ({ title, subtitle, link, imageSrc }: ArticleItemProps) => {
  return (
    <Link
      href={`${ROUTES.educationDetail}/${link}`}
      className="mb-4 flex items-center gap-x-4 rounded-[32px] bg-primary-500 p-4 pr-14"
    >
      <div className="flex h-full max-h-[80px] w-full max-w-[80px]">
        <Image
          src={imageSrc}
          width={80}
          height={80}
          quality={100}
          sizes="100"
          alt={title}
          className="flex aspect-square rounded-2xl object-cover"
        />
      </div>
      <div className="w-fit">
        <Typography type="h3" className="mb-1">
          {title}
        </Typography>
        <Typography type="l" className="text-primary-200">
          {subtitle}
        </Typography>
      </div>
    </Link>
  )
}

export default ArticleItem
